import { api } from "#api";

export const popupBillingPortal = async () => {
  const { url } = await api.post("/stripe/billing-portal", {});
  window.open(url, "_blank", "width=600,height=600");
};

export const navigateToBillingPortal = async () => {
  const { url } = await api.post("/stripe/billing-portal", {
    returnUrl: window.location.href,
  });
  // or window.open(url, "_blank"); to open in a new tab, but then
  // they need a page to be redirected to after they are done
  window.location.assign(url);
};

export const navigateToPaymentMethod = async () => {
  const { url } = await api.post("/stripe/payment-method", {
    // page that user will be redirected to after they are done
    returnUrl: window.location.href,
  });
  window.location.assign(url);
};

export interface NavigateToCheckoutArgs {
  returnUrl: string;
  completeUrl: string;
}

export const navigateToCheckout = async (price: string, args: NavigateToCheckoutArgs) => {
  const { url } = await api.post("/subscriptions/session", {
    price,
    returnUrl: new URL(args.returnUrl, window.location.origin).href,
    completeUrl: new URL(args.completeUrl, window.location.origin).href,
  });
  window.location.assign(url);
};

export interface SubscriptionChanges {
  price?: string; // new price key to change to
  cancelAtPeriodEnd?: boolean; // if true, subscription will be cancelled at the end of the current period
}

export const updateSubscription = async (subscriptionId: string, changes: SubscriptionChanges) => {
  await api.post("/subscriptions/:subscription", changes, {
    params: { subscription: subscriptionId },
  });
};

export const cancelSubscription = async (subscriptionId: string) => {
  await api.delete("/subscriptions/:subscription", undefined, {
    params: { subscription: subscriptionId },
  });
};
